import PlatformError from "../PlatformError";

export default new PlatformError("ERROR", "Your screen orientation did not match what was required for this study", "Screenout", "User failed orientation check", "app.start.orientation")
